import React, { PureComponent } from 'react';
import PieChart from 'recharts/lib/chart/PieChart';
import Pie from 'recharts/lib/polar/Pie';
import Cell from 'recharts/lib/component/Cell';

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,value
}) => {

  const radius = innerRadius + (outerRadius - innerRadius) * 0.6;
  const x = cx + radius * Math.cos(-(midAngle) * RADIAN);
  const y = cy + radius * Math.sin(-(midAngle) * RADIAN);
  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {value}
    </text>
  );
};

export default class Piechart extends PureComponent {

  render() {
    const {data, industryData} = this.props
    return (
      <div>
      {data&&<div style={{display:'flex'}}>
        <PieChart width={220} height={220} style={{float:'left'}}>
          <Pie
            data={data}
            cx={100}
            cy={100}
            labelLine={false}
            label={renderCustomizedLabel}
            outerRadius={100}
            fill="#8884d8"
            dataKey="value"
          >
            {
              data.map((item, index) => <Cell key={`cell-${index}`} fill={item.color} />)
            }
          </Pie>
        </PieChart>
        <div style={{float:'right', width: 230, marginLeft:35, marginTop: 10}}>
          {
            data.map((item, index)=>(
              <div key={`item_${index}`} style={{color:item.color, display: 'flex', justifyContent: 'space-between', alignItems:'center'}}>
                <div style={{display:'flex', alignItems:'center'}}>
                <div style={{width: 16, height: 16, borderRadius: 8, backgroundColor:item.color}}/>
                <span style={{marginLeft:5}}>{item.name}</span>
                </div>
                <div>{item.value}</div>
              </div>
            ))
          }
        </div>
        </div>}
        {industryData&&<div>
          <p style={{margin:0, fontSize:18}}>Other Stats and Links</p>
          <div><strong>{industryData.Job_openings}</strong>: Number Job Openings in {industryData.City} Fintech Companies</div>
          <div><strong>{industryData.Growth}%</strong>: Average Growth in {industryData.City} Fintech Companies</div>
          {
            [...Array(5)].map((e, index) => {

            // times(5, index=>{
              const text = industryData[`Text${index+1}`]
              const link = industryData[`Link${index+1}`]
              return (
                <div key={index+'text'}>
                  {text}
                  {link&&<a href={link} target='_blank'><img src='/static/img/link.png' width={15} style={{marginTop:-5, marginLeft: 5}}/></a>}
                </div>
              )}
            )
          }
        </div>}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./client/src/components/piechart_industry.js